/// <amd-module name="SuiteCommerce.GridOrder.MatrixChildItem.Prototype"/>
define("SuiteCommerce.GridOrder.MatrixChildItem.Prototype", ["require", "exports", "SuiteCommerce.GridOrder.Common.DependencyProvider", "SuiteCommerce.GridOrder.Utils", "SuiteCommerce.GridOrder.Instrumentation", "SuiteCommerce.GridOrder.Configuration", "grid_order_cell_matrix_child_item.tpl"], function (require, exports, DependencyProvider_1, Utils_1, Instrumentation_1, GridOrder_Configuration_1, matrixChildItemTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var MatrixChildItemViewPrototype = /** @class */ (function () {
        function MatrixChildItemViewPrototype() {
        }
        Object.defineProperty(MatrixChildItemViewPrototype.prototype, "template", {
            get: function () {
                return matrixChildItemTemplate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatrixChildItemViewPrototype.prototype, "events", {
            get: function () {
                return {
                    'change .grid-order-cell-matrix-child-item-quantity': 'quantityChanged',
                    'click .grid-order-stock-info-back-in-stock-button': 'openStockNotificationsComponent',
                };
            },
            enumerable: true,
            configurable: true
        });
        MatrixChildItemViewPrototype.prototype.quantityChanged = function (event) {   

            var quantityInputElementValue = jQuery(event.currentTarget).val() || '0';   

            var quantity = parseInt(quantityInputElementValue, 10);
            this.model.quantity = quantity;

            if (!_.isNumber(quantity) || _.isNaN(quantity) || quantity < 0) {
               // $(event.currentTarget).siblings(".grid-order-stock-info").append('<span id= "input-validation">Invalid quantity value</span>');
            }
           
            var backOrder = this.model.get("isbackorderable")
            var quantityAvailable = this.model.get("quantityavailable")
            // var isCustomBackorderMessage = this.isCustomEUBackoredr();
            var isPreOrderComingSoonMsg = this.isPreOrderComingSoon();
            
            if (quantity > quantityAvailable) {
                if (!backOrder) {
                    var backorderDisallow = $(event.currentTarget).siblings(".grid-order-stock-info").find(".grid-order-stock-backorder-quantity");
                    backorderDisallow.addClass("backorder-disable");
                    backorderDisallow.css('display','block');
                    backorderDisallow.html(`Reduce qty, Only <b>${parseInt(quantityAvailable)}</b> left in stock`);
                    backorderDisallow.closest('.grid-order-stock-info').find('.grid-order-stock-info-quantity').hide();
                }else{
                    var backorderAllow = $(event.currentTarget).siblings(".grid-order-stock-info").find(".grid-order-stock-backorder-quantity");
                    backorderAllow.addClass("backorder-allow");
                    backorderAllow.css('display','block');
                    if(this.model.get("outofstockmessage").toLowerCase().includes("pre-order")){
                        backorderAllow.html();
                    }
                    else if(this.model.get("outofstockmessage").toLowerCase().includes("ships within")){
                        backorderAllow.html(`<b>${this.model.get("outofstockmessage")}</b>`);
                        backorderAllow.closest('.grid-order-stock-info').find('.grid-order-stock-info-quantity').hide();
                        backorderAllow.closest('.grid-order-stock-info').find('.allow-backorder').hide();
                    }
/*                     else if (isCustomBackorderMessage){
                        backorderAllow.html(`Available for pre-order – Expected mid-March.`);
                        backorderAllow.closest('.grid-order-stock-info').find('.grid-order-stock-info-quantity').hide();
                        backorderAllow.closest('.grid-order-stock-info').find('.allow-backorder').hide();
                    } */
                    else if (isPreOrderComingSoonMsg){
                        backorderAllow.html(`Coming Soon! Pre-Order Now.`);
                        backorderAllow.closest('.grid-order-stock-info').find('.grid-order-stock-info-quantity').hide();
                        backorderAllow.closest('.grid-order-stock-info').find('.allow-backorder').hide();
                    }
                    else{
                        // backorderAllow.html(`<b>${parseInt(quantity)-parseInt(quantityAvailable)}</b> unit on backorder`);
                        backorderAllow.html(`This item is on backorder.`);
                        backorderAllow.closest('.grid-order-stock-info').find('.grid-order-stock-info-quantity').hide();
                        backorderAllow.closest('.grid-order-stock-info').find('.allow-backorder').hide();
                    }
                }
            }else{
                var backorderRemove = $(event.currentTarget).siblings(".grid-order-stock-info").find(".grid-order-stock-backorder-quantity");
                backorderRemove.removeClass("backorder-allow");
                backorderRemove.removeClass("backorder-disable");
                backorderRemove.html(``);
                backorderRemove.css('display','none');
                backorderRemove.closest('.grid-order-stock-info').find('.grid-order-stock-info-quantity').show();
                backorderRemove.closest('.grid-order-stock-info').find('.allow-backorder').show();

            }

            var backorderDisallow = $(".grid-order-stock-info").find(".grid-order-stock-backorder-quantity");
            if(backorderDisallow.hasClass("backorder-disable")){
                $("#grid-order-add-to-cart").attr('disabled','disabled');
            }
            
            var productInfo = {};
            var rows = document.querySelectorAll('tbody[data-view="GridOrder.Rows.Collection"] tr.grid-order-row');
            rows.forEach(function(row) {
              var priceElements = row.querySelectorAll('small.grid-order-cell-matrix-child-item-price');
              priceElements.forEach(function(priceElement) {
                var currentSize = priceElement.getAttribute('size');
                var currentColor = priceElement.getAttribute('color');
                var currentQuantityInput = jQuery(priceElement).siblings('.grid-order-cell-matrix-child-item-quantity');
                var currentInputValue = currentQuantityInput.val();

                var currentNumericValue = parseFloat(priceElement.textContent.replace(/[^\d.,-]/g, '').replace(',', '.'));
                var currentSubtotal = currentNumericValue * currentInputValue;

                if (currentSize) {
                  if (!productInfo[currentSize]) {
                    productInfo[currentSize] = {
                      total: 0
                    };
                  }
            
                  if (currentColor) {
                    if (!productInfo[currentSize][currentColor]) {
                      productInfo[currentSize][currentColor] = {
                        quantity: 0,
                        total: 0
                      };
                    }
                    
                    productInfo[currentSize][currentColor].quantity = currentInputValue;
                    productInfo[currentSize][currentColor].total += currentSubtotal;
                  } else {
                    // Add quantity to currentSize if currentColor is not available
                    if (!productInfo[currentSize].quantity) {
                      productInfo[currentSize].quantity = 0;
                    }
            
                    productInfo[currentSize].quantity += currentInputValue;
                  }
            
                  productInfo[currentSize].total += currentSubtotal;
                }
              });
            
            });

            for (var size in productInfo) {
                var quantity = parseInt(productInfo[size].quantity)
                var total = productInfo[size].total;
                
                if (total < 0) {
                    $("#grid-order-add-to-cart").attr('disabled','disabled');
                }
                var element = document.querySelector('td[size="' + size + '"] .summary-value-grid');
                var summaryQty = document.querySelector('td[size="' + size + '"] .qty-grid');
                 var len =   $('[id^=row-colum-matrix-size-total-value]').length

              if(len >= 1){
                var totalElement = document.querySelector('td[size="' + size + '"]#row-colum-matrix-size-total-value');
                if(total){
                    totalElement.textContent = total.toFixed(2);
                }else{
                    totalElement.textContent = '';
                }
              }else{             
                var totalElement = document.querySelector('td[size="' + size + '"]#row-matrix-size-total-value');
                if (element && totalElement) {
                   if(quantity && total ) {
                       element.textContent = quantity;
                       summaryQty.textContent = ' Qty.'
                       totalElement.textContent = total.toFixed(2);
                   }else{
                    element.textContent = '';
                    totalElement.textContent = '';
                    summaryQty.textContent = ''
                   }    
                }
            }
              }
            // var $totalElements = jQuery('.grid-order-footer .total-value');
          
            // Object.entries(productInfo).forEach(function([size, info], index) {
            //   var totalIndex = $totalElements.length - 1 - index;
            //   var Value = info.total
            //   var totalValue;            
            //   if (Value) {
            //     if(Value < 0){
            //         $("#grid-order-add-to-cart").attr('disabled','disabled');
            //     } 
            //         totalValue = info.total.toFixed(2);
            //   }

            //   var currentHref = window.location.href;
            //   if (currentHref.includes("Fuse-Jr") ||currentHref.includes("Luna-Monofin")) {
            //     $totalElements.eq(totalIndex).text(totalValue);
            //   } else {
            //     $totalElements.eq(index).text(totalValue);
            //   }
            // });
          
        };
/*         MatrixChildItemViewPrototype.prototype.isCustomEUBackoredr = function () {
            // Custom backorder message Stability-Snorkel new colorways
            var preorderSkus = [
                '1.05.021.194',
                '1.05.021.195',
                '1.05.021.193'
            ];

            var currentSku = this.model.get('itemid');
            var isPreorderSku = preorderSkus.indexOf(currentSku) !== -1;
            var isEu = location.hostname.indexOf('b2b.finisswim.eu') !== -1;
            return isEu && isPreorderSku;
        }; */

        MatrixChildItemViewPrototype.prototype.isPreOrderComingSoon = function () {
            // Custom backorder message Goggle new colorways
            var preorderSkus = [
                "3.45.069.190",
                "3.45.069.144",
                "3.45.069.170",
                "3.45.069.232",
                "3.45.009.292",
                "3.45.009.347",
                "3.45.009.368",
                "3.45.009.370",
                "3.45.011.170",
                "3.45.011.188",
                "3.45.011.190",
                "3.45.011.232",
                "3.45.011.233",
                "3.45.011.292"
            ];

            var currentSku = this.model.get('itemid');
            var isPreorderSku = preorderSkus.indexOf(currentSku) !== -1;
            return isPreorderSku;
        };


        MatrixChildItemViewPrototype.prototype.openStockNotificationsComponent = function () {
            var stockNotificationsComponent = this.container.getComponent('StockNotifications');
            var matrixChildItemInternalId = this.model.internalId;
            var matrixParentItemInternalId = this.model.parentInternalId;
            if (stockNotificationsComponent) {
                if (stockNotificationsComponent.showSubscriptionModal) {
                    try {
                        stockNotificationsComponent.showSubscriptionModal({
                            selectedProductId: matrixChildItemInternalId,
                            matrixParentId: matrixParentItemInternalId,
                            modalTitle: Utils_1.Utils.translate('Subscribe to $(0)', this.model.itemId),
                        });
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
                else {
                    stockNotificationsComponent.showSuscriptionModal(matrixChildItemInternalId, matrixParentItemInternalId);
                }
                var stockNotificationsUsageRequestLog = Instrumentation_1.default.getLog('stockNotificationsUsageRequestLog');
                stockNotificationsUsageRequestLog.setParameters({
                    activity: 'SC Stock Notifications usage from SC Grid Order',
                });
                stockNotificationsUsageRequestLog.submit();
            }
        };
        MatrixChildItemViewPrototype.prototype.clearErrorMessage = function (event) {
            var $quantityInputField = jQuery(event.currentTarget);
            $quantityInputField.removeClass('data-validation-error');
            $quantityInputField.removeAttr('data-toggle');
            // @ts-ignore
            $quantityInputField.tooltip('hide');
            // @ts-ignore
            $quantityInputField.tooltip('destroy');
        };
        MatrixChildItemViewPrototype.prototype.showErrorMessage = function (event) {
            var $quantityInputField = jQuery(event.currentTarget);
            $quantityInputField.addClass('data-validation-error');
            $quantityInputField.attr('data-toggle', 'grid-order-tooltip');
            // @ts-ignore
            $quantityInputField.tooltip('destroy');
            // @ts-ignore
            $quantityInputField.tooltip({
                title: this.model.getErrorMessage(),
                placement: 'bottom',
            });
        };
        MatrixChildItemViewPrototype.prototype.isBackInStockNotificationIsEnabled = function () {
            return !this.model.isInStock
                && !this.model.isBackorderable
                && !!this.container.getComponent('StockNotifications')
                && this.model.isBackInStockNotificationEnabled;
        };
        MatrixChildItemViewPrototype.prototype.isQuantityInputEnabled = function () {
            return !!this.model.isInStock || !!this.model.isBackorderable;
        };
        MatrixChildItemViewPrototype.prototype.getContext = function () {
            var price = '0';
            if (!DependencyProvider_1.ProfileModel.getInstance().hidePrices()) {
                var onlineCustomerPriceDetail = this.model.onlineCustomerPriceDetails;
                price = onlineCustomerPriceDetail ? onlineCustomerPriceDetail.onlinecustomerprice_formatted : '0';
            }   
            var value = this.model.get("custitem12");
            var trimmedSize;
            if(value){
                trimmedSize  = value.replace(/\s/g, "");
            }
            var outOfStockMessage  ;
            var backOrder =  this.model.get("isbackorderable")
            var quantity =  this.model.get("quantityavailable")
            // var isCustomBackorderMessage = this.isCustomEUBackoredr();
            var isPreOrderComingSoonMsg = this.isPreOrderComingSoon();

/*             if(quantity === 0){
                if(!backOrder){
                    outOfStockMessage = "Currently Unavailable"
                }else{
                    if(this.model.get("outofstockmessage").toLowerCase().includes("pre-order")){
                        outOfStockMessage = this.model.get("outofstockmessage")
                    }
                    else if(this.model.get("outofstockmessage").toLowerCase().includes("ships within")){
                        outOfStockMessage = this.model.get("outofstockmessage")
                    }
                    else if(isCustomBackorderMessage){
                        outOfStockMessage = "Available for pre-order – Expected mid-March."
                    }
                    else{
                        outOfStockMessage = "This item on backorder"
                    }
                }
            } */

            if(quantity === 0){
                if(!backOrder){
                    outOfStockMessage = "Currently Unavailable"
                }else{
                    if(this.model.get("outofstockmessage").toLowerCase().includes("pre-order")){
                        outOfStockMessage = this.model.get("outofstockmessage")
                    }
                    else if(this.model.get("outofstockmessage").toLowerCase().includes("ships within")){
                        outOfStockMessage = this.model.get("outofstockmessage")
                    }
                    else if(isPreOrderComingSoonMsg){
                        outOfStockMessage = "Coming Soon! Pre-Order Now."
                    }
                    else{
                        outOfStockMessage = "This item on backorder"
                    }
                }
            }

            $(function(){
                const rows = document.querySelectorAll('.grid-order-row');

                rows.forEach(row => {
                  const hasChildItemClass = row.querySelector('.grid-order-cell-matrix-child-item');
                
                  if (!hasChildItemClass) {
                    const hasNotAvailableClass = row.querySelector('.grid-order-cell-matrix-child-item.not-available');
                    if (!hasNotAvailableClass) {
                      const notAvailableTd = document.createElement('td');
                      notAvailableTd.className = 'grid-order-cell-matrix-child-item not-available';
                      const notAvailableSpan = document.createElement('span');
                      notAvailableSpan.className = 'grid-order-cell-matrix-child-item-not-available';
                      const notAvailableImg = document.createElement('img');
                      notAvailableImg.className = 'not-available-img';
                      notAvailableImg.src = '/images/Finis2022-images/icons/not-available-v1.svg';
                      notAvailableImg.alt = 'Not Available';
                      notAvailableSpan.appendChild(notAvailableImg);
                      notAvailableTd.appendChild(notAvailableSpan);
                      row.appendChild(notAvailableTd);
                    }
                  }
                });
                
                
            })


            return {
                price: price,
                internalId: this.model.internalId,
                itemId: this.model.itemId,
                isInStock: this.model.isInStock,
                showOutOfStockMessage: this.model.showOutOfStockMessage,
                outOfStockMessage:  outOfStockMessage,
                showStockInformation: this.model.showStockInformation,
                stockInformationText: this.model.stockInformationText,
                quantityInputIsEnabled: this.isQuantityInputEnabled(),
                backInStockNotificationIsEnabled: this.isBackInStockNotificationIsEnabled(),
                combinationNotAvailableLabel: GridOrder_Configuration_1.GridOrderConfiguration.combinationNotAvailable,
                stockNotificationsButtonLabel: GridOrder_Configuration_1.GridOrderConfiguration.stockNotificationsLabel,
                isquantityavailable:quantity,
                customSize : this.model.get("custitem13"),
                size : trimmedSize,
                custitem3 : this.model.get("custitem3"),
                labelValues : this.model.get("custitem9"),
                backOrder : backOrder,
                custitem11 : this.model.get("custitem11"),
                custitem14 : this.model.get("custitem14"),
                custitem10 : this.model.get("custitem10"),

            };
        };
        return MatrixChildItemViewPrototype;
    }());
    exports.MatrixChildItemViewPrototype = MatrixChildItemViewPrototype;
});
